import { ToastContentProps } from "react-toastify";
import cx from 'clsx';

type ApiErrorNotificationProps = ToastContentProps<{
    title: string;
    content: string;
    action: () => void;
  }>;
  
  function ApiErrorNotification({
    closeToast,
    data
  }: ApiErrorNotificationProps) {
    return (
      <div className="w-full flex justify-between items-center mr-8">
        <div className="ml-4">
        <h3 className="text-white text-body m-0">
          {data.title}
        </h3>
        <p className="m-0 text-small">{data.content}</p>
        </div>
        <div>
        <button
            onClick={() => {
                data?.action()
                closeToast()
            }}
            className={cx('btn-secondary-alt', 'px-[15px] py-[8px] text-xs')}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  export default ApiErrorNotification